<template>
    <b-overlay
            :show="loading"
            rounded="sm"
    >
        <b-row>
            <b-col>
                <b-card
                        title="جزئیات رنگ محصول"
                >
                    <b-form
                            @submit.prevent
                    >
                        <b-row>

                            <b-col
                                    class="mt-2 form-size"
                                    md="6"
                                    offset-md="3"
                            >
                                <b-row>

                                    <b-col md="4">
                                        <b-form-group
                                                label="رنگ"
                                                label-for="ColorId"
                                        >
                                            <color
                                                    v-model="Form.ColorId"
                                                    :multiple="false"
                                                    :clearable="false"
                                            />
                                        </b-form-group>
                                    </b-col>

                                    <b-col md="4">
                                        <b-form-group
                                            label="وضعیت"
                                            label-for="Status"
                                        >
                                            <v-select
                                                v-model="Form.Status"
                                                :options="enums('ProductStatus')"
                                                dir="rtl"
                                                label="text"
                                                name="Status"
                                                :clearable="false"
                                                :reduce="x => x.value"
                                            />
                                        </b-form-group>
                                    </b-col>

                                    <b-col md="4">
                                        <b-form-group
                                            label="بارکد"
                                            label-for="Barcode"
                                        >
                                            <b-form-input
                                                v-model="Form.Barcode"
                                                autocomplete="off"
                                                name="Barcode"
                                                :disabled="Form.HasVariety"
                                            />
                                        </b-form-group>
                                    </b-col>

                                    <b-col md="4">
                                        <b-form-group label="قیمت"
                                                      label-for="Price">
                                            <b-input-group append="تومان">
                                                <cleave
                                                        v-model="Form.Price"
                                                        class="form-control"
                                                        :raw="false"
                                                        :options="options"
                                                />
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>


                                    <b-col md="4">
                                        <b-form-group label="تخفیف"
                                                      label-for="Discount">
                                            <b-input-group append="تومان">
                                                <cleave
                                                        v-model="Form.Discount"
                                                        class="form-control"
                                                        :raw="false"
                                                        :options="options"
                                                />
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>

                                    <b-col md="4">
                                        <b-form-group
                                                label="تعداد"
                                                label-for="Quantity"
                                        >
                                            <b-form-input
                                                    v-model="Form.Quantity"
                                                    autocomplete="off"
                                                    type="number"
                                            />
                                        </b-form-group>
                                    </b-col>

                                    <b-col md="4">
                                        <b-form-group
                                                label="حداقل تعداد سفارش"
                                                label-for="MinOrderQuantity"
                                        >
                                            <b-form-input
                                                    v-model="Form.MinOrderQuantity"
                                                    autocomplete="off"
                                                    type="number"
                                            />
                                        </b-form-group>
                                    </b-col>

                                    <b-col md="4">
                                        <b-form-group
                                                label="حداکثر تعداد سفارش"
                                                label-for="MaxOrderQuantity"
                                        >
                                            <b-form-input
                                                    v-model="Form.MaxOrderQuantity"
                                                    autocomplete="off"
                                                    type="number"
                                            />
                                        </b-form-group>
                                    </b-col>


                                    <b-col md="12">
                                        <b-form-group
                                                label="توضیحات"
                                                label-for="Description"
                                        >
                                            <div class="form-label-group">
                                                <b-form-input
                                                        id="Description"
                                                        v-model="Form.Description"
                                                        name="Description"
                                                        autocomplete="off"
                                                />
                                            </div>
                                        </b-form-group>

                                    </b-col>

                                    <b-col cols="12">
                                        <hr>
                                    </b-col>
                                    <b-col class="mt-1 mb-2 text-center">
                                        <b-button
                                                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                                type="submit"
                                                variant="primary"
                                                class="mr-1"
                                                @click="save"
                                        >
                                            ذخیره
                                        </b-button>
                                        <b-button
                                                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                                                variant="outline-secondary"
                                                @click="back"
                                        >
                                            بازگشت
                                        </b-button>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-card>
            </b-col>
        </b-row>
    </b-overlay>
</template>

<script>
import Color from "@/tools/color.vue";

export default {
    name: 'ProductColorDetails',
    components: {Color},
    data() {
        return {
            Form: {
                Id: null,
                Title: null,
                Image: null,
                Description: null,
            },
            loading: false,
            options: {
                numeral: true,
                numeralThousandsGroupStyle: 'thousand',
                numeralDecimalScale: 4,
            },
        }
    },
    created() {
        if (this.$route.params.id) {
            this.Form.Id = this.$route.params.id
            this.get()
        }else{
            this.Form.ProductId = this.$route.query.productid
        }
    },
    methods: {
        save() {
            let url = this.$api.productcolor.add
            if (this.$route.params.id) {
                url = this.$api.productcolor.update
            }

            const form = JSON.parse(JSON.stringify(this.Form))

            if (form.Price){
                form.Price = form.Price.replaceAll(',', '')
            }

            if (form.Discount)   {
                form.Discount = form.Discount.replaceAll(',', '')
            }

            this.loading = true
            this.$http.post(
                url, form,
            )
                .then(() => {
                    this.back()
                })
                .finally(() => {
                    this.loading = false
                })
        },
        imageRenderer(event) {
            const fileReader = new FileReader()
            fileReader.readAsDataURL(event.target.files[0])

            fileReader.onload = () => {
                this.Form.Image = fileReader.result
            }
        },
        get() {
            this.loading = true
            this.$http.post(
                this.$api.productcolor.get, {
                    Id: this.Form.Id,
                },
            )
                .then(res => {
                    this.loading = false
                    this.Form = res.data
                })
        },
    },
}
</script>

<style scoped>
.image .media-body {
    align-self: flex-end;
}
</style>
